<script>
/* eslint no-unused-vars: 'off' */

// import { resolveComponent } from 'vue';

import navigationButtons from '@/components/navigationButtons';
import myHelp from '@/components/myHelp';
import ctMyAnalysis from '@/components/myAnalysis/ctMyAnalysis';
import lrMyAnalysis from '@/components/myAnalysis/lrMyAnalysis';
import current from '@/scripts/current';
import sectionHeader from '@/components/sub/sectionHeader';
import metricsHelper from '@/scripts/metricsHelper';

function getMyAnalysisName(currentType) {
    switch (currentType.toLowerCase()) {
        case 'lr':
            return 'lr-my-analysis';
        case 'ct':
            return 'ct-my-analysis';
        default:
            return null;
    }
}

export default {
    props: ['forReport', 'router', 'nextButtonValue', 'nextButtonTitle'],
    components: {
        navigationButtons,
        myHelp,
        ctMyAnalysis,
        lrMyAnalysis,
        sectionHeader
    },
    render(h) {
        const vm = this;
        const forReport = Boolean(vm.forReport);

        let navigationButtons = forReport
            ? ''
            : h('navigation-buttons', {
                  props: {
                      nextButtonValue: vm.nextButtonValue,
                      nextButtonTitle: vm.nextButtonTitle
                  }
              });

        //const currentStep = current.selectionModel.currentStep;

        let myHelp = h('my-help', { ref: 'help', props: { forReport } });

        let myAnalysisName = getMyAnalysisName(vm.currentType);

        let myAnalysis = myAnalysisName
            ? h(myAnalysisName, {
                  ref: 'myAnalysis',
                  props: {
                      router: vm.router,
                      forReport
                  }
              })
            : '';

        let backForReport = '';
        if (forReport) {
            backForReport = h('input', {
                attrs: {
                    type: 'button',
                    value: 'Back',
                    class: 'btn btn-secondary btn-block hide-on-print',
                    title: 'Back'
                },
                on: {
                    click: (e) => vm.backClicked(e)
                }
            });
            backForReport = (
                <div class="info-container">
                    <div></div>
                    <div class="row hidden-print back-button">
                        {backForReport}
                    </div>
                </div>
            );
        }
        const hTitle = 'Help with this step...';
        const aTitle = 'My Analysis';
        return (
            <div>
                {navigationButtons}
                <div class="info-container headers">
                    <div class="on-desktop">
                        {helpHeader(h, forReport, 'myHelpDesktop', hTitle)}
                    </div>
                    <div class="on-desktop">
                        {myAnalysisHeader(
                            h,
                            forReport,
                            'myAnalysisDesktop',
                            aTitle
                        )}
                    </div>
                </div>
                <div class="info-container">
                    <div class="on-mobile">
                        {helpHeader(h, forReport, 'myHelp', hTitle)}
                    </div>
                    <div>{myHelp}</div>
                    <div class="on-mobile">
                        {myAnalysisHeader(h, forReport, 'myAnalysis', aTitle)}
                    </div>
                    <div>{myAnalysis}</div>
                </div>
                {backForReport}
            </div>
        );
    },

    created() {
        let vm = this;
        vm.currentType = current.currentType;
    },
    data: function () {
        var vm = this;
        return {
            currentType: ''
        };
    },
    methods: { backClicked }
};

function myAnalysisHeader(h, forReport, isFor) {
    return h('section-header', {
        props: {
            title: 'My Analysis',
            isFor,
            forReport
        }
    });
}

function helpHeader(h, forReport, isFor, title) {
    return h('section-header', {
        props: {
            title: 'Help with this step...',
            isFor,
            forReport
        }
    });
}

function backClicked() {
    const vm = this;
    metricsHelper.back();
    vm.router.push(current.navigation.getPreviousPage());
}
</script>

<style scoped>
.spaced-out {
    margin-top: 20px;
    margin-bottom: 20px;
}

.dropdown-menu label.radio input[type='radio'] {
    visibility: hidden;
}

.dropdown-menu label.radio {
    padding-left: 10px;
}
.info-container {
    align-items: stretch;
}
.info-container > div {
    width: 49%;
}
.info-container > div.headers {
    align-self: flex-end;
}
input[type='button'] {
    width: 45%;
    font-weight: 800;
    max-width: 220px;
}
@media (max-width: 767px) {
    .info-container {
        display: block;
        align-items: unset;
    }
    .info-container > div {
        width: 100%;
    }
    .on-desktop {
        display: none;
    }
}
@media (min-width: 768px) {
    .on-mobile {
        display: none;
    }
    .info-container > div {
        margin: 0 10px;
    }
}
</style>
